import { LayoutType } from "@Components/weather-report/subsection/SubsectionEntry";
import { Image as ImageModel } from "@MeteoApi/models/Image";
import { getArticleImageUrl } from "@Utils/article";
import classNames from "classnames";
import { useDarkMode } from "usehooks-ts";

export type ImageFormat = LayoutType | "avatar" | "avatar-small";
export type ImageProps = ImageModel & { format: ImageFormat; testId?: string };

const Image = ({ format, alt_text: altText, testId, ...rest }: ImageProps) => {
  const { isDarkMode } = useDarkMode();
  const src = getArticleImageUrl(rest, format, isDarkMode);
  const title = altText ?? undefined;
  const alt = format === "avatar" ? `Profilbild von ${title}` : title;

  return (
    <div
      className={classNames({
        "m:max-w-[288px]": format === "compact",
        "m:size-14 m:overflow-hidden m:rounded-full m:border m:border-solid m:border-warmgrey-10 m:bg-[#dadad2] m:dark:border-warmgrey-1050":
          format === "avatar",
        "m:size-10 m:overflow-hidden m:rounded-[40px] m:border m:border-solid m:border-warmgrey-10 m:dark:border-warmgrey-1050":
          format === "avatar-small",
      })}>
      <img
        className={classNames("m:h-full! m:w-full! m:object-cover", {
          "m:block!": format === "default",
          "m:h-full!": format === "avatar",
        })}
        src={src}
        title={title}
        alt={alt}
        aria-hidden={format === "compact"}
        data-testid={testId}
      />
    </div>
  );
};

export default Image;
